import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";

const FacilityBreadcrumbSchema = ({ baseUrl, stateUrl, cityUrl, facilityUrl, facilityName, state, city }) => {
	const breadcrumbSchema = {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		"@id": `${baseUrl}${facilityUrl}#breadcrumbs`,
		itemListElement: [
			{
				"@type": "ListItem",
				item: {
					"@id": `${baseUrl}/`,
					name: "Home"
				}
			},
			stateUrl && {
				"@type": "ListItem",
				item: {
					"@id": `${baseUrl}${stateUrl}`,
					name: state
				}
			},
			cityUrl && {
				"@type": "ListItem",
				item: {
					"@id": `${baseUrl}${cityUrl}`,
					name: `${city}, ${state}`
				}
			},
			facilityUrl && {
				"@type": "ListItem",
				item: {
					"@id": `${baseUrl}${facilityUrl}`,
					name: facilityName
				}
			}
		].filter(Boolean).map((item, index) => ({ ...item, position: index + 1 }))
	};

	return <Schema schema={breadcrumbSchema} />;
};

FacilityBreadcrumbSchema.propTypes = {
	baseUrl: PropTypes.string.isRequired,
	stateUrl: PropTypes.string.isRequired,
	cityUrl: PropTypes.string.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	facilityName: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired
};

export default FacilityBreadcrumbSchema;
